import { Tooltip } from "@fluentui/react-components";
import FluentUiIcon from "../assets/fluent-ui-icon";

export const getInitials = (name) => {
  if (name) {
    let initials = name.match(/\b\w/g) || [];
    initials = (
      (initials.shift() || "") + (initials.pop() || "")
    ).toUpperCase();
    return initials;
  }
  return "";
};

export const scrollToTop = () => {
  document.getElementById("topComments").scrollIntoView({
    behavior: "smooth",
  });
};

export const scrollToBottomByClassName = (className) => {
  setTimeout(() => {    
    const elements = document.getElementsByClassName(className);
    if (elements.length > 0 && elements[0]) {
      elements.scrollTo({
        top: elements.scrollHeight,
        behavior: "smooth"
      });
    }
  }, 100);
};

export const scrollToTopByClassName = (className) => {
  setTimeout(() => {
    // TAD-5644 — Guard against the element being absent. The setTimeout
    // can fire after the consuming React tree unmounts (especially under
    // Vitest, where the DOM is torn down between tests), and `div[0]`
    // would be undefined. Crashing here showed up in CI as an Uncaught
    // Exception. Also a latent prod bug when navigating away within 100ms.
    const div = document.getElementsByClassName(className);
    if (div[0]) div[0].scrollTop = 0;
  }, 100);
};

export const scrollToBottomById = (Id) => {
  setTimeout(() => {
    // TAD-5644 — Same guard as `scrollToTopByClassName` above.
    const element = document.getElementById(Id);
    if (element) element.scrollTop = element.scrollHeight;
  }, 100);
};

export const renderLabelWithInfoTooltip = (label, infotext) => (
  <>
    <span className="label ml-2">{label}</span>
    <Tooltip content={<span>{infotext}</span>} relationship="label">
      <span className="ml-1" >
        <FluentUiIcon
          name="InfoRegular"
          size={16}
          color="#000"
        />
      </span>
    </Tooltip>

  </>
);

export const URL_SCHEMES = [
  "https://",
  "http://",
  "sftp://",
  "ftp://",
  "blob:",
  "file://",
  "mailto:",
  "tel:",
  "ssh://",
  "wss://",
  "ws://",
];